module.exports = __webpack_public_path__ + "img/bell.d351dc5b.png";